




























import { CommonUtils } from '@/util/commonUtils';
import { Component , Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../config/objectFactory';
import { MedTransGoConstants } from '../util/constants';
@Component({})
export default class TopNavigationBar extends Vue {
    private fullname: string = '';
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();

    public mounted() {
        setTimeout(() => {
            this.fullname = ObjectFactory.getCacheService().getSessionInfo().fullname;
            const arr = this.fullname.split(' ');
            let initialLetters = '';
            if (arr.length > 1) {
                initialLetters = arr[0].charAt(0) + arr[1].charAt(0);
            } else if (arr.length === 1) {
                initialLetters = arr[0].charAt(0) + arr[0].charAt(1);
            }
            const element = document.getElementById('logoFullName');
            if (element) {
                element.setAttribute('data-letters', initialLetters.toUpperCase());
            }
        });
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }
}
